import React from "react";
import { Button } from "react-bootstrap";

interface ISubmitButtonProps {
    workingText: string;
    delay?: number;
    text: string;
    variant?:
        | "primary"
        | "secondary"
        | "success"
        | "danger"
        | "warning"
        | "info"
        | "dark"
        | "light"
        | "link"
        | "outline-primary"
        | "outline-secondary"
        | "outline-success"
        | "outline-danger"
        | "outline-warning"
        | "outline-info"
        | "outline-dark"
        | "outline-light";
    size?: "sm" | "lg";
    type?: "button" | "reset" | "submit";
    onClick?: (evt: React.MouseEvent) => void;
    onWorkerComplete?: () => void;
}

interface ISubmitButtonState {
    isWorking: boolean;
}

export default class WorkingButton extends React.Component<
    ISubmitButtonProps,
    ISubmitButtonState
> {
    private _interval: NodeJS.Timeout | undefined;
    private _textCopy: string;
    private _delay: number = 0;

    constructor(props: ISubmitButtonProps) {
        super(props);

        this._textCopy = props.text;

        if (this.props.delay) {
            this._delay = this.props.delay;
        }

        this.state = {
            isWorking: false,
        };
    }

    public get isWorking(): boolean {
        return this.state.isWorking;
    }

    handleClick = (evt: React.MouseEvent): void => {
        this.startWorker(evt);
    };

    startWorker = (evt: React.MouseEvent): void => {
        if (this._interval === undefined) {
            this._textCopy = this.props.workingText;
            this.setState({ isWorking: true });

            if (this.props.onClick) {
                this.props.onClick(evt);
            }

            this._interval = setInterval(() => {
                this.stopWorker();
            }, this._delay);
        }
    };

    stopWorker = (): void => {
        if (this._interval) {
            clearInterval(this._interval);
            this._textCopy = this.props.text;
            this._interval = undefined;
            this.setState({ isWorking: false });

            if (this.props.onWorkerComplete) {
                this.props.onWorkerComplete();
            }
        }
    };

    render() {
        return (
            <Button
                variant={this.props.variant}
                type={this.props.type}
                size={this.props.size}
                onClick={(evt: React.MouseEvent) => this.handleClick(evt)}
            >
                {this._textCopy}
            </Button>
        );
    }
}
